import React from 'react'
import './AwesomeFurniture.css'

export const CuratedCombos = () => {
    return (

        <div className='showContainer'>
            <div className='showContainerLeft'>
                <iframe width="650" height="360" src="https://www.youtube.com/embed/E-WlvrPNVlI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <div className='showContainerright'>
                <h2>CURATED COMBOS FOR EVERY SPACE</h2>
                <p>We carefully put together our combos to enhance your home. Be it your living room, dining or bedroom, these combos come together to create the perfect home.</p>
                <button>Explore Products</button>
            </div>
        </div>
    )
}
